import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { ToastNotificationService } from './toast-notification.service';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
  constructor(
    private router: Router,
    private toastNotificationService: ToastNotificationService
  ) {}

  handle404And422(navigateTo: string) {
    return (error: any) => {
      if (
        (error.status === 422 && error.error?.detail?.[0]?.type === 'uuid_parsing') ||
        error.status === 404 || error.status === 500
      ) {
        const message = error.error?.detail || 'Something went wrong';
        this.toastNotificationService.showNotification({ type: 'error', message });
        this.router.navigate([navigateTo]);
        return throwError(() => new Error('Navigation triggered'));
      }
      return throwError(() => error);
    };
  }
}
